import { type PropsWithChildren } from 'react'

import styles from './styles.module.scss'

export const PresetContainer = ({ children }: PropsWithChildren) => (
  <div className={styles.container}>{children}</div>
)
